<template>
    <li :class="isAfterNow(member.gameweekAwardLimitExpiryDate) ? 'locked' : ''">
        <a v-if="lockTime" @click.prevent="lockInfo();btnSfx();" href="#" class="locked-timer small">
            {{ $t('team.member_list_item_award_limit_text'+(isAfterNow(member.gameweekAwardLimitExpiryDate) ? '' : '_season')) }} 
            <b>{{ lockTime }}</b> <i class="fas fa-info-circle"></i>
        </a>
        <div>{{ order }}.</div>
        <img :src="member.user.avatarUrl != undefined ? member.user.avatarUrl : '/images/male-default.png'" alt="User image"/>
        <div :class="member.role == 'OWNER' ? 'text-yellow' : ''">
            <h5 class="mb-0"><b>{{ member.user.username }}</b></h5>
            <div v-if="member.role == 'OWNER'" class="small">{{ $t('team.role_'+member.role.toLowerCase()) }}</div>
        </div>
        <div class="team-members-list__right ml-auto">
            <span class="gameweek">
                <img src="/images/icon-trophy.png"/> 
                <b>{{ member.gameweekPoints ? member.gameweekPoints.abbr() : 0 }}</b>
            </span>
            <span v-if="config.seasonEnabled" :class="'season'+(!isAfterNow(member.gameweekAwardLimitExpiryDate) && isAfterNow(member.seasonAwardLimitExpiryDate) ? ' text-danger':'')">
                <img src="/images/icon-season-points.png"/> 
                <b>{{ member.seasonPoints ? member.seasonPoints.abbr() : 0 }}</b>
            </span>
            <div v-if="user.teamRole != undefined && user.teamRole == 'OWNER'" class="settings">
                <b-button v-if="user.id != member.user.id && !member.active" @click="settings();btnSfx();" variant="primary" size="sm"><i class="fas fa-cog"></i></b-button>
            </div>
        </div>
    </li>
</template>
<script>
import moment from 'moment';
import Vue from 'vue'

import api from '../../api'

const MemberListItem = Vue.component('team-member-list-item', {

    props: {
        order: Number,
        member: Object,
        myRole: String
    },
    
    data(){
    	return {
            lockTime: undefined,
    	};
    },

    limitExpiryDateTimer: null,

    computed:{
        config(){
            return this.$store.state.config.data;
        },

        user() {
            return this.$store.state.auth.user;
        },

        networkTimeDiff(){
            return this.$store.state.config.networkTimeDiff;
        }
    },
    
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        isAfterNow(time){
            return time != undefined && moment.utc(time).isAfter(moment.utc() + this.networkTimeDiff);
        },

        clearTimers(){
            if(this.limitExpiryDateTimer != null){
                clearInterval(this.limitExpiryDateTimer);
                this.limitExpiryDateTimer = null;
            }
        },

        lockInfo(){
            const $this = this;
            let text = this.$t('team.member_list_item_award_limit_popup_text'+(this.member.gameweekAwardLimitExpiryDate == undefined ? '_season' : ''));

            this.$bvModal.msgBoxOk($this.htmlToVNode(text), {
                title: this.$t('team.member_list_item_award_limit_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: $this.$t('base.btn_ok'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        settings(){
            this.$emit('openSettings', this.member.user, this.member.role);
        },

        htmlToVNode(html) {
            return [
                this.$createElement('div', { domProps: { innerHTML: html } })
            ]
        },

        formatTime(time){
            if(time < 0) time = 0; // fix negative 
            let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff));

            if(t.asDays() > 1)
                return t.days()+"d"+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ "h" : "");
            else if(t.hours() > 0)
                return this.pad2(t.hours()) + ":" + this.pad2(t.minutes())+"h";
            else if(t.minutes() > 0)
                return this.pad2(t.minutes()) + ":" + this.pad2(t.seconds())+"m";

            return '00:'+this.pad2(t.seconds())+"s";
        },

        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },
    },

    mounted(){
        const $this = this;
        let time = undefined;

        // for test only
        // this.member.gameweekAwardLimitExpiryDate = "2022-09-08T10:17";
        // this.member.seasonAwardLimitExpiryDate = "2022-09-08T10:18";

        if(this.member.gameweekAwardLimitExpiryDate)
            time = moment.utc(this.member.gameweekAwardLimitExpiryDate);

        if(this.member.seasonAwardLimitExpiryDate)
            time = moment.utc(this.member.seasonAwardLimitExpiryDate);

        if(time != undefined && this.isAfterNow(time)){
            this.lockTime = this.formatTime(time);
            
            // run timer if limit expiry in one hour
            if(moment.utc(moment.utc() + $this.networkTimeDiff).subtract(1, 'hours').isBefore(time))
                this.limitExpiryDateTimer = setInterval(() => { 
                    let nt = moment.utc() + $this.networkTimeDiff;
                    if(moment.utc(nt).isBefore(time))
                        $this.lockTime = $this.formatTime(time);
                    else {
                        $this.lockTime = undefined;
                        $this.clearTimers();
                    }
                }, 1000);
        }
    },

    beforeDestroy(){
        this.clearTimers();
    }

});

export default MemberListItem;
</script>